import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../../../../../../../src/helpers/reselectHelpers';
import {removeCardGroupFromCardsAsyncAction} from '../../../../../../../../../../src/store/data/cardGroups/cardGroupsActions';
import {contactsManagerCardGroupPageRefreshAction} from '../../../../../../../../../../src/store/panels/contacts/contactsManager/table/contactsManagerTableActions';
import {ContactsTableMultiRemoveFromListAction} from './contactsTableMultiRemoveFromListAction';

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  onRemoveSuccess: contactsManagerCardGroupPageRefreshAction,
  onRemoveCardsFromCardGroupsAsync: removeCardGroupFromCardsAsyncAction,
}));

export const ContactsTableMultiRemoveFromListActionContainer = connect(
  null,
  mapDispatchToProps,
)(ContactsTableMultiRemoveFromListAction);
